export default function () {
    const wrap = document.querySelector('[data-logos]');

    if (!wrap) return;

    const items = [...wrap.querySelectorAll('[data-logo-item]')];

    let interval;

    function clearActive() {
        items.forEach(item => item.classList.remove('is-active'));
    }

    function getChunkSize() {
        if (window.innerWidth >= 1200) {
            return 10; // 5 + 5
        }

        if (window.innerWidth >= 760) {
            return 6; // 3 + 3
        }

        return 1; // mobile one by one
    }

    function runSlider() {
        clearInterval(interval);
        clearActive();

        if (!items.length) return;

        const chunkSize = getChunkSize();

        let groupIndex = 0;

        function showGroup() {
            clearActive();

            const start = groupIndex * chunkSize;
            let end = start + chunkSize;

            // loop back if exceeded
            if (start >= items.length) {
                groupIndex = 0;
                return showGroup();
            }

            items.slice(start, end).forEach(item => {
                item.classList.add('is-active');
            });

            groupIndex++;

            // restart loop
            if (end >= items.length) {
                groupIndex = 0;
            }
        }

        showGroup();

        interval = setInterval(showGroup, 5000);
    }

    runSlider();

    let resizeTimeout;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
            runSlider();
        }, 200);
    });
}